import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';

interface chapitre {
  chapitre_name: string;
  start_time?: number;
  end_time?: number;
}

interface VideoLink {
  ID: string;
  Lien: string;
  State: string;
}

const intro_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Intro.png`; 
const caresse_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Petting.png`; 
const sixNine_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_69.png`; 
const andromaque_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Gemini.png`;
const bateauIvre_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Captain.png`;
const branletteEspagnole_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Titjob.png`;
const cowgirl_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Cowgirl.png`;
const chaiseBascule_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Reverse Cowgirl.png`;
const anulingus_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Rimjob.png`;
const ejaculation_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Cumshot.png`;
const cunnilingus_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Pussy Licking.png`;
const hommeDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Barbell.png`;
const levrette_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Doggystyle.png`;
const levretteDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Standing Doggystyle.png`;
const masturbation_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Masturbation.png`;
const leClou_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Piledriver.png`;
const petiteCuilleres_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Spoon.png`;
const pipe_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Blowjob.png`;
const unionElephant_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Boat.png`;
const missionary_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Missionary.png`;
const missionaryDebout_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Keeper.png`;
const eagle_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Eagle.png`;
const grasshopper_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Grasshopper.png`;
const hommePorte_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Column.png`;
const slowDance_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Slow Dance.png`;
const vis_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Screw.png`;
const placeConfort_Icon = `${process.env.PUBLIC_URL}/Symbols/IMG_Comfortable Place.png`;

const chapterIcons: { name: string; src: string }[] = [
  {name: 'Intro', src: intro_Icon},
  {name: 'Petting', src: caresse_Icon},
  {name: '69', src: sixNine_Icon},
  {name: 'Gemini', src: andromaque_Icon},
  {name: 'Captain', src: bateauIvre_Icon},
  {name: 'Titjob', src: branletteEspagnole_Icon},
  {name: 'Cowgirl', src: cowgirl_Icon},
  {name: 'Reverse Cowgirl', src: chaiseBascule_Icon},
  {name: 'Rimjob', src: anulingus_Icon},
  {name: 'Cumshot', src: ejaculation_Icon},
  {name: 'Pussy Licking', src: cunnilingus_Icon},
  {name: 'Barbell', src: hommeDebout_Icon},
  {name: 'Doggystyle', src: levrette_Icon},
  {name: 'Standing Doggystyle', src: levretteDebout_Icon},
  {name: 'Masturbation', src: masturbation_Icon},
  {name: 'Piledriver', src: leClou_Icon},
  {name: 'Spoon', src: petiteCuilleres_Icon},
  {name: 'Blowjob', src: pipe_Icon},
  {name: 'Boat', src: unionElephant_Icon},
  {name: 'Missionary', src: missionary_Icon},
  {name: 'Keeper', src: missionaryDebout_Icon},
  {name: 'Eagle', src: eagle_Icon},
  {name: 'Grasshopper', src: grasshopper_Icon},
  {name: 'Column', src: hommePorte_Icon},
  {name: 'Slow Dance', src: slowDance_Icon},
  {name: 'Screw', src: vis_Icon},
  {name: 'Comfortable Place', src: placeConfort_Icon},
];

const CheckingChapter = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [videosLinks, setVideosLinks] = useState<VideoLink[]>([]);
  const [index, setIndex] = useState<number>(0);

  const [chapters, setChapters] = useState<chapitre[]>([]);
  const [indexChapitre, setIndexChapitre] = useState<number>(0);
  
  const [videoTime, setVideoTime] = useState<number>(0);

  const [startValidated, setStartValidated] = useState<'none' | 'validate' | 'correct'>('none');
  const [endValidated, setEndValidated] = useState<'none' | 'validate' | 'correct'>('none');
  const [nameValidated, setNameValidated] = useState<'none' | 'validate' | 'correct'>('none');

  const [startCorrection, setStartCorrection] = useState<number | null>(null);
  const [endCorrection, setEndCorrection] = useState<number | null>(null);
  const [chapterCorrection, setChapterCorrection] = useState<string | null>(null);

  const [chapterNameOptionsVisible, setChapterNameOptionsVisible] = useState(false);

  const [chapterCorrections, setChapterCorrections] = useState<any[]>([]);

  const plageStart = localStorage.getItem('plageStart');
  const plageEnd = localStorage.getItem('plageEnd');

  useEffect(() => {
    const fetchVideos = async () => {
      if (!plageStart || !plageEnd) return;
      try {
        const response = await axios.get(`https://foodybrain.com/api/ANTIMUS/get_checking_videos`, {
          params: {
            plageStart,
            plageEnd,
          },
        });

        const data = response.data;
        setVideosLinks(data);
      } catch (error) {
        console.error('Error API :', error);
      }
    };
    fetchVideos();
  }, [plageStart, plageEnd]);

  useEffect(() => {
    const fetchChapitres = async () => {
      if (videosLinks.length === 0 || !videosLinks[index]) return;
      try {
        const id_video = videosLinks[index].ID
        const response = await axios.get(`https://foodybrain.com/api/ANTIMUS/get_video_chapitres`, {
          params: {
            id_video
          },
        });

        const data = response.data.map((chap: chapitre) => ({
          ...chap,
          start_time: chap.start_time ?? 0
        }));

        setChapters(data);
        setIndexChapitre(0);
        setChapterCorrections(new Array(data.length).fill(null));
      } catch (error) {
        console.error('Error API :', error);
      }
    };
    fetchChapitres();
  }, [videosLinks, index]);

  const correctedChapterName = chapterCorrection ?? chapters[indexChapitre]?.chapitre_name;
  const matchedIcon = chapterIcons.find((icon) => icon.name === correctedChapterName);
  const correctedStart = startCorrection ?? chapters[indexChapitre]?.start_time;
  const correctedEnd = endCorrection ?? chapters[indexChapitre]?.end_time;

  const handleStartChapter = () => {
    if(videoRef.current && !correctedStart) {
      videoRef.current.currentTime = 0;
    }
    else if(videoRef.current && correctedStart) {
      videoRef.current.currentTime = correctedStart;
    }
  };

  const handleEndChapter = () => {
    if(videoRef.current && correctedEnd) {
      videoRef.current.currentTime = correctedEnd;
    }
  };

  const handleNext = async () => {
    const currentCorrection = {
      chapitre_name: chapterCorrection ?? chapters[indexChapitre].chapitre_name,
      start_time: startCorrection ?? chapters[indexChapitre].start_time,
      end_time: endCorrection ?? chapters[indexChapitre].end_time,
    };

    const updatedCorrections = [...chapterCorrections];
    updatedCorrections[indexChapitre] = currentCorrection;
    setChapterCorrections(updatedCorrections);

    if (indexChapitre + 1 < chapters.length) {
      setIndexChapitre(indexChapitre + 1);
    } else {
      try { 
        await axios.post(`https://foodybrain.com/api/ANTIMUS/correct_video_chapitres`, {
          id_video: videosLinks[index].ID,
          corrected_chapitres: updatedCorrections
        });
      } catch (error) {
        console.error('Error API :', error);
      }

      setChapterCorrections([]);
      setIndexChapitre(0);
      setIndex(index + 1);
    }
    resetValidation();
  };

  const resetValidation = () => {
    setStartValidated('none');
    setEndValidated('none');
    setNameValidated('none');
    setStartCorrection(null);
    setEndCorrection(null);
    setChapterCorrection(null);
  };

  const handleEditTime = (type: string, nb: number) => {
    if (videoRef.current) {
      let currentTime = Math.floor(videoRef.current.currentTime);
      if (type === "plus") {
        videoRef.current.currentTime = currentTime + nb;
      } else if (type === "moins") {
        videoRef.current.currentTime = Math.max(0, currentTime - nb);
      }
    }
  };

// Fonction pour gérer la sauvegarde des chapitres
const flagVideo = async (idVideo: string, commentaire: string) => {
  let APIcomment;
  if(commentaire === '') {
    APIcomment = "Regular Flag Comment"
  } else {
    APIcomment = commentaire;
  }

  if (idVideo === '') {
    alert('Problem to flag the video. Please contact the admin.');
    return;
  }

  try {
    // Appel à l'API pour sauvegarder les chapitres
    const response = await axios.post('https://foodybrain.com/api/ANTIMUS/flag_video', {
      id_video: idVideo,
      comment: APIcomment
    });

    alert('Video flag successfully !');
  } catch (error) {
    console.error('Flag error :', error);
    alert('Flag error. Please contact the admin.');
  }
};

const [flagComment, setFlagComment] = useState<string>("");

const handleFlagButton = () => {
    flagVideo(videosLinks[index].ID, flagComment);
    setFlagComment("");
    resetValidation();

    const newIndex = index+1;
    setIndex(newIndex);
};

  const isNextEnabled = [startValidated, endValidated, nameValidated].every((v) => v !== 'none');

  return (
    <div style={{ padding: '5px', backgroundColor: '#f0f0f0', minHeight: '100vh', textAlign: 'center' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '20px' }}>Checking Chapter</h1>

      {videosLinks.length > 0 && videosLinks.length > index && chapters.length > 0 ? (
        <>
            <button
              onClick={handleFlagButton}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                borderRadius: '5px',
                backgroundColor: '#ff3d3d',
                color: 'white',
                border: 'none',
                cursor: videosLinks[index] ? 'pointer' : 'not-allowed', // Changer le curseur si désactivé
                opacity: videosLinks[index] ? 1 : 0.6  // Rendre le bouton plus transparent s'il est désactivé
              }}
              disabled={!videosLinks[index]}
            >
              Flag the video
            </button>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
            <label htmlFor="flag-comment" style={{ marginRight: '5px' }}>Flag Comment:</label>
              <textarea
                id="flag-comment"
                value={flagComment}  // État pour stocker la valeur du commentaire
                onChange={(e) => setFlagComment(e.target.value)}  // Mettre à jour l'état lors de la saisie
                placeholder="Enter your comment here"
                style={{
                  width: '500px',
                  height: '15px',
                  padding: '10px',
                  fontSize: '14px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                }}
              />
          </div>

          <h2>Vidéo ID n°{videosLinks[index].ID} - Chapter {indexChapitre + 1}/{chapters.length}</h2>

          <div 
            style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'flex-start', 
              gap: '40px', 
              marginTop: '20px',
              maxWidth: '90%',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >  
          {/* VIDEO + INFOS à gauche */}
          <div style={{ flex: '1', textAlign: 'center' }}>
            <video ref={videoRef} controls width="600" style={{ marginBottom: '10px' }}>
              <source src={`https://foodybrain.com/videos/video_${videosLinks[index].ID}.mp4`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
                Chapter Name : {correctedChapterName} {' '}
                {matchedIcon && (
                  <img
                    src={matchedIcon.src}
                    alt={matchedIcon.name}
                    style={{ height: '80px', verticalAlign: 'middle', marginLeft: '10px' }}
                  />
                )}
              </p>
              <p style={{ fontSize: '18px', marginTop: '10px' }}>
                Start : {correctedStart}s | End : {correctedEnd}s
              </p>
            </div>

            <div style={{ marginTop: '10px' }}>
              <button onClick={handleStartChapter} style={{ marginRight: '10px' }}>Go to Start</button>
              <button onClick={handleEndChapter}>Go to End</button>
            </div>

            <p style={{ marginTop: '20px' }}>Current time: {videoTime}s</p>

            <div style={{ margin: '20px 0' }}>
              <button onClick={() => handleEditTime("moins", 5)} style={{ marginRight: '10px' }}>-5 sec</button>
              <button onClick={() => handleEditTime("moins", 1)} style={{ marginRight: '10px' }}>-1 sec</button>
              <button onClick={() => handleEditTime("plus", 1)} style={{ marginRight: '10px' }}>+1 sec</button>
              <button onClick={() => handleEditTime("plus", 5)}>+5 sec</button>
            </div>
          </div>

          {/* FORMULAIRES à droite */}
          <div style={{ width: '40%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
            
            {/* Start Time */}
            <div style={{ background: 'white', padding: '15px', borderRadius: '5px', width: '100%' }}>
              <h2>Start Time</h2>
              <button onClick={() => { setStartValidated('validate'); setStartCorrection(null); }} style={{ backgroundColor: startValidated === 'validate' ? 'green' : 'lightgray', margin: '5px' }}>Validate</button>
              <button onClick={() => setStartValidated('correct')} style={{ backgroundColor: startValidated === 'correct' ? 'red' : 'lightgray', margin: '5px' }}>Correct</button>
              {startValidated === 'correct' && (
                <input
                  type="number"
                  value={startCorrection ?? ''}
                  onChange={(e) => setStartCorrection(parseInt(e.target.value))}
                  placeholder="Correction start time"
                  style={{ marginTop: '10px', width: '100%' }}
                />
              )}
            </div>

            {/* End Time */}
            <div style={{ background: 'white', padding: '15px', borderRadius: '5px', width: '100%' }}>
              <h2>End Time</h2>
              <button onClick={() => { setEndValidated('validate'); setEndCorrection(null); }} style={{ backgroundColor: endValidated === 'validate' ? 'green' : 'lightgray', margin: '5px' }}>Validate</button>
              <button onClick={() => setEndValidated('correct')} style={{ backgroundColor: endValidated === 'correct' ? 'red' : 'lightgray', margin: '5px' }}>Correct</button>
              {endValidated === 'correct' && (
                <input
                  type="number"
                  value={endCorrection ?? ''}
                  onChange={(e) => setEndCorrection(parseInt(e.target.value))}
                  placeholder="Correction end time"
                  style={{ marginTop: '10px', width: '100%' }}
                />
              )}
            </div>

            {/* Chapter Name */}
            <div style={{ background: 'white', padding: '15px', borderRadius: '5px', width: '100%' }}>
              <h2>Chapter Name</h2>
              <button onClick={() => { setNameValidated('validate'); setChapterCorrection(null); }} style={{ backgroundColor: nameValidated === 'validate' ? 'green' : 'lightgray', margin: '5px' }}>Validate</button>
              <button onClick={() => { setNameValidated('correct'); setChapterNameOptionsVisible(true); }} style={{ backgroundColor: nameValidated === 'correct' ? 'red' : 'lightgray', margin: '5px' }}>Correct</button>

              {chapterNameOptionsVisible && nameValidated === 'correct' && (
                <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                  {chapterIcons.map(({ name, src }) => (
                    <div key={name} style={{ textAlign: 'center' }}>
                      <img
                        src={src}
                        alt={name}
                        onClick={() => setChapterCorrection(name)}
                        style={{
                          height: '60px',
                          cursor: 'pointer',
                          border: chapterCorrection === name ? '4px solid green' : '2px solid transparent',
                          borderRadius: '8px'
                        }}
                      />
                      <p style={{ fontSize: '12px', marginTop: '5px' }}>{name}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>

        </div>


        <button
          onClick={handleNext}
          disabled={!isNextEnabled}
          style={{
            marginTop: '30px',
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: isNextEnabled ? '#007bff' : '#cccccc',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: isNextEnabled ? 'pointer' : 'not-allowed'
          }}
        >
          Next Check Video
        </button>
      </>
      ) : (
        <p>You have finished checking your range of video.</p>
      )}
    </div>
  );
};

export default CheckingChapter;
